import { Box, Transition } from '@wix/design-system';
import React, { useCallback } from 'react';
import { useStopGeneratingGuard } from '../hooks/use-stop-generating-guard';
import { DrillInScreenHeader } from './drill-in-screen-header';
export const AltTextScreenLayout = _ref => {
  let {
    headerTitle,
    onClickBack,
    onClickClose,
    closeButtonAriaLabel,
    content,
    footer,
    showHeader = false,
    showHeaderDivider = true,
    animateOnLoad = true,
    contentRef
  } = _ref;
  const {
    guard
  } = useStopGeneratingGuard();
  const handleClickBack = useCallback(() => guard(onClickBack), [guard, onClickBack]);
  const handleClickClose = useCallback(() => guard(onClickClose), [guard, onClickClose]);
  return /*#__PURE__*/React.createElement(Transition, {
    animateOnLoad: animateOnLoad,
    enterAnimation: {
      moveIn: {
        direction: 'rightToLeft',
        distance: '300px',
        duration: 'fast01',
        easing: 'enterEasing'
      }
    }
  }, /*#__PURE__*/React.createElement(Box, {
    bottom: "0",
    dataHook: "alt-text-screen-layout",
    direction: "vertical",
    height: "100%",
    left: "0",
    position: "absolute",
    right: "0",
    top: "0"
  }, showHeader && /*#__PURE__*/React.createElement(Box, {
    flex: "0 0 auto"
  }, /*#__PURE__*/React.createElement(DrillInScreenHeader, {
    closeButtonAriaLabel: closeButtonAriaLabel,
    showDivider: showHeaderDivider,
    title: headerTitle,
    onClickBack: handleClickBack,
    onClickClose: handleClickClose
  })), /*#__PURE__*/React.createElement(Box, {
    dataHook: "alt-text-screen-content",
    direction: "vertical",
    flex: "1 1 auto",
    overflow: "auto",
    ref: contentRef
  }, content), /*#__PURE__*/React.createElement(Box, {
    dataHook: "alt-text-screen-footer",
    flex: "0 0 auto"
  }, footer)));
};
//# sourceMappingURL=alt-text-screen-layout.js.map